import type { Severity } from './types.js';

export const SEVERITY_COLORS: Record<Severity, string> = {
  high: '#ff4d4f',
  medium: '#faad14',
  low: '#52c41a',
};
